/**
 * The customer app's Supabase client.
 *
 * A distinct `storageKey` keeps the customer's anonymous session from colliding
 * with a merchant session if both apps are opened on the same origin.
 */

import { createAppClient } from '@yummy/db';

export const supabase = createAppClient('yummy.customer.auth');
